import styled from "styled-components";

export const Count = styled.div`
    display: inline-block;
    color: ${({ theme }) => theme.colors.tertiary[700]};
`;
